import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { IconSwitchModule } from './components/icon-switch/icon-switch.module';
import { InputFileModule } from './components/input-file/input-file.module';
import { NamedTemplateModule } from './components/named-template';
import { PaginatedListModule } from './components/paginated-list/paginated-list.module';
import { PanelStackModule } from './components/panel-stack/panel-stack.module';
import { SelectModule } from './components/select/select.module';
import { TextHighlightModule } from './components/text-highlight';
import { UploadListModule } from './components/upload-list/upload-list.module';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule, ReactiveFormsModule],
    exports: [
        AutocompleteModule,
        SelectModule,
        InputFileModule,
        UploadListModule,
        PanelStackModule,
        NamedTemplateModule,
        TextHighlightModule,
        PaginatedListModule,
        IconSwitchModule,
    ],
})
export class TopconCwUiComponentsModule {}
